import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { navLinks } from "@/mocks/site";

export default function Navbar() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const isHome = location.pathname === "/";
  const transparent = isHome && !scrolled;

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) =>
    path === "/" ? location.pathname === "/" : location.pathname.startsWith(path);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        transparent
          ? "bg-transparent"
          : "bg-background-50/95 backdrop-blur-md border-b border-background-200/80"
      }`}
    >
      <div className="container-site flex items-center justify-between h-16 md:h-20">
        <Link to="/" className="flex items-center gap-2.5 cursor-pointer">
          <span className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center">
            <span className="font-heading font-extrabold text-foreground-950 text-lg md:text-xl">
              芒
            </span>
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading font-bold text-lg md:text-xl ${
                transparent ? "text-background-50" : "text-foreground-950"
              }`}
            >
              芒果传媒
            </span>
            <span
              className={`text-[10px] tracking-[0.2em] uppercase ${
                transparent ? "text-background-200" : "text-foreground-500"
              }`}
            >
              Mango Media
            </span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`px-3.5 py-2 rounded-md text-sm font-medium transition-colors cursor-pointer ${
                isActive(link.path)
                  ? transparent
                    ? "text-primary-400"
                    : "text-primary-700"
                  : transparent
                    ? "text-background-100 hover:text-primary-400"
                    : "text-foreground-700 hover:text-primary-700"
              }`}
            >
              {link.name}
            </Link>
          ))}
          <Link
            to="/contact"
            className="ml-3 px-4 py-2 rounded-md bg-primary-500 text-foreground-950 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            合作咨询
          </Link>
        </nav>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMobileOpen((v) => !v)}
          className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md ${
            transparent ? "text-background-50" : "text-foreground-950"
          }`}
        >
          <i className={`text-2xl ${mobileOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
        </button>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/80">
          <nav className="container-site py-3 flex flex-col">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`py-3.5 px-1 text-base font-medium border-b border-background-200/60 last:border-0 ${
                  isActive(link.path) ? "text-primary-700" : "text-foreground-800"
                }`}
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/contact"
              className="mt-4 mb-2 py-3 rounded-md bg-primary-500 text-foreground-950 text-center font-semibold"
            >
              合作咨询
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}